import { createContext, useReducer, useEffect } from 'react'

export const AuthContext = createContext()

export const authReducer = (state, action) => {
    switch (action.type) {
        case 'LOGIN':
            return {
                user: action.payload,
                allUsers: null,
                resetRequested: false
            }
        case 'LOGOUT':
            return {
                user: null,
                allUsers: null,
                resetRequested: false
            }
        case 'SET_PASSWORD_REQUESTED':
            return {
                user: state.user,
                allUsers: state.allUsers,
                resetRequested: false
            }
        case 'ALL_USERS':
            return {
                user: state.user,
                allUsers: action.payload,
                resetRequested: false
            }
        default:
            return state
    }
}

export const AuthContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(authReducer, {
        user: null,
        allUsers: null,
        resetRequested: false
    })

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user'))

        if (user) {
            dispatch({ type: 'LOGIN', payload: user })
        }

    }, [])

    return (
        <AuthContext.Provider value={{ ...state, dispatch }}>
            {children}
        </AuthContext.Provider>
    )
}
